import RootLayout from '../../layouts/Root/RootLayout'
import MerchantHeader from './MerchantHeader'
import routes from './routes'

const MerchantLayout = (page) => <RootLayout HeaderComponent={MerchantHeader} page={page} routes={routes} />

export default MerchantLayout
